export const IOTS_VOLUME_CHART_ENDPOINT = '/iot-api/chart/v1/iots-volume';
export const IOTS_UPTIME_CHART_ENDPOINT = '/iot-api/chart/v1/iots-uptime';
